import apiClient from '@/services/apiClient'
import {
    DASHBOARD_SALES_MATCH_QUOTE_FILTER_DATE,
    DASHBOARD_SALES_MATCH_QUOTE,
    DASHBOARD_SALES_MATCH_QUOTE_BY_FUZZY_REFERENCE,
    DASHBOARD_SALES_MATCH_QUOTE_CREATE_MATCH,
} from '@/data/url'

const dashboardMatchSaleQuoteService = {
    async fetchDashboardByDate(beginDate, endDate) {
        const response = await apiClient.post(DASHBOARD_SALES_MATCH_QUOTE_FILTER_DATE, {
            begin_date: beginDate,
            end_date: endDate,
        })
        return response.data
    },

    async fetchMatches(soId) {
        const response = await apiClient.post(DASHBOARD_SALES_MATCH_QUOTE, { so_id: soId })
        return response.data
    },

    async fetchMatchesByFuzzyReference(soId, quoteReference) {
        const response = await apiClient.post(DASHBOARD_SALES_MATCH_QUOTE_BY_FUZZY_REFERENCE, {
            so_id: soId,
            quote_reference: quoteReference,
        })
        return response.data
    },

    async createMatch({ saleId, quoteId, searchActionId, soIndex }) {
        const response = await apiClient.post(DASHBOARD_SALES_MATCH_QUOTE_CREATE_MATCH, {
            sale_id: saleId,
            quote_id: quoteId,
            search_action_id: searchActionId,
            so_index: soIndex,
        })
        return response.data
    },
}

export default dashboardMatchSaleQuoteService
